import { TGetOrderResponse } from '@p2p/services';

/**
 * Заявка оплачивается только по ссылке провайдера — кнопкой «Оплатить» в
 * PayByLink (P2P-2808). Флаг `payment_via_link` считает бэкенд (со страницы не
 * должно быть видно, какой провайдер выдал реквизит — P2P-2101), ссылка лежит в
 * ios_link / android_link.
 *
 * P2P-2890: у таких заявок нельзя показывать и банковские диплинки «Быстрой
 * оплаты» (DeepLinkMobile / DeepLinkDesktop): они собирают перевод из полей
 * реквизита, а у link-only заявки номер телефона/счёта не отдаётся, банк может
 * быть заглушкой. Для IronPay СБП (НСПК) банк плательщика (client_bank_code)
 * приходит почти всегда — без этой проверки на телефоне первым экраном была бы
 * кнопка «Оплатить с SberPay» в никуда, а PayByLink прятался под свёрнутым блоком.
 */
export const isPayViaLinkOrder = (order?: TGetOrderResponse | null): boolean =>
  Boolean(order?.payment_via_link && (order?.ios_link || order?.android_link));
